import { MediaField } from '../../../../system/field';
import { MediaCategory, MediaResource } from '../../../../system/media';

export const isPhoto = (item: MediaResource) =>
  item.MEDIA_CATEGORY === MediaCategory.Photo;

export const setPreferredPhoto = (
  mediaList: MediaResource[],
): MediaResource[] => {
  if (!mediaList || mediaList.length <= 0) return mediaList; // Nothing to do

  // Get all photos
  const photos = mediaList.filter(isPhoto);

  if (photos.length === 0) return mediaList; // Nothing to do

  // Find the photo with the lowest MEDIA_DISPLAY_ORDER (First photo)
  // Using reduce to find the object with the minimum value
  const preferredPhoto = photos.reduce(
    (prev, curr) =>
      curr.MEDIA_DISPLAY_ORDER < prev.MEDIA_DISPLAY_ORDER ? curr : prev,
    photos[0],
  );

  // Return a new array with PREFERRED_PHOTO_YN = true
  return mediaList.map((item) => {
    if (isPhoto(item)) {
      if (item.MED_VW_KEY === preferredPhoto.MED_VW_KEY) {
        return { ...item, [MediaField.PREFERRED_PHOTO_YN]: true };
      }

      // For other photos, only set to false if the property is already set
      // OR if it is wanted to ensure no other photo is accidentally preferred.
      if (item[MediaField.PREFERRED_PHOTO_YN]) {
        return { ...item, [MediaField.PREFERRED_PHOTO_YN]: false };
      }
    }

    return { ...item };
  });
};
